var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStructured = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "10px",
    viewBox: "0 0 12 10",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "globe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0.-Menu-General-",
    transform: "translate(-34.000000, -436.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.-Visualization-Copy",
    transform: "translate(33.000000, 413.989154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Universe-Selection",
    transform: "translate(0.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 0.998265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlined-/-Image-/-details",
    transform: "translate(0.000000, 1.199479)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 13.8974164 0 13.8974164 13.8974164 0 13.8974164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73717705,2.31623607 L6.94870821,11.5811803 L12.1602394,2.31623607 L1.73717705,2.31623607 Z M3.69439653,3.4743541 L10.2088105,3.4743541 L6.94870821,9.26494427 L3.69439653,3.4743541 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "#FFFFFF"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStructured, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/structured.b321c837.svg";
export { ForwardRef as ReactComponent };